// Phần THUẦN của bộ lọc URL (không React) — tách khỏi bo-loc.tsx để kiểm thử được bằng vitest (tsconfig.test.json
// không bật JSX/DOM). bo-loc.tsx re-export toàn bộ, nơi dùng vẫn import từ './bo-loc'.
import { khoangKy, tenKy } from '../../server/chi-so';
import { NGUONG_CHAM_NGAY, NGUONG_QUA_HAN_NGAY, tuoiNgay } from './hang-doi-duyet';
import { khopHan, khopTim, laKyThang, laLocHan, laMucTieu, LOAI_VIEC, taoTrongKy, thuTuUuTien, TT_DANG_MO, xongTrong7Ngay, xongTrongKy, type LocHan, type Viec } from './viec';

// Bộ lọc sống TRÊN URL (?nguoi=3&tag=khan-cap&q=…): gửi link là người kia thấy đúng khung nhìn đó,
// bấm Back là về bộ lọc trước. Không có trạng thái thứ hai để lệch.
export interface BoLoc {
  tim: string;
  nguoi: number | 'chua-giao' | null;
  tag: string | null;
  brand: string | null;
  linh_vuc: string | null;
  uu_tien: string | null;
  doi_tac: string | null;
  han: LocHan | null;
  xong: string | null;    // chỉ việc đã đóng: '7-ngay' (ô "Xong 7 ngày qua" ở Tổng quan) hoặc một tháng 'YYYY-MM' (Báo cáo kỳ)
  tai_san: string | null; // việc gắn tài sản thương hiệu `tai-san:<slug>` (trang Tài sản dẫn tới đây)
  pha: string | null;     // pha hành vi khách hàng `pha:p0…p5` (sơ đồ pha × kênh dẫn tới đây)
  kenh: string | null;    // kênh triển khai `kenh:<slug>`
  tt: string | null;      // trạng thái đang mở `tt:inbox|san-sang|dang-chay|cho-duyet|tac-nghen` (ô "Trạng thái" ở thanh lọc)
  loai: string | null;    // loại việc `loai:viec|quyet-dinh|loi` (ô "Loại")
  tao: string | null;     // chỉ việc TẠO trong một tháng 'YYYY-MM' (mục "Mở mới" của Báo cáo kỳ dẫn tới đây)
  cho: number | null;     // chỉ việc đang chờ duyệt ĐÃ từ 3 hoặc 7 ngày (NGUONG_CHAM_NGAY / NGUONG_QUA_HAN_NGAY)
}

export const KHOA_URL: Record<keyof BoLoc, string> = { tim: 'q', nguoi: 'nguoi', tag: 'tag', brand: 'brand', linh_vuc: 'linh-vuc', uu_tien: 'uu-tien', doi_tac: 'doi-tac', han: 'han', xong: 'xong', tai_san: 'tai-san', pha: 'pha', kenh: 'kenh', tt: 'tt', loai: 'loai', tao: 'tao', cho: 'cho' };

export function docUrl(search: string): BoLoc {
  const p = new URLSearchParams(search);
  const nguoi = p.get('nguoi');
  const han = p.get('han');
  const xong = p.get('xong');
  const tao = p.get('tao');
  const cho = Number(p.get('cho'));
  return {
    tim: p.get('q') || '',
    nguoi: nguoi === 'chua-giao' ? 'chua-giao' : nguoi && /^\d+$/.test(nguoi) ? Number(nguoi) : null,
    tag: p.get('tag'),
    brand: p.get('brand'),
    linh_vuc: p.get('linh-vuc'),
    uu_tien: p.get('uu-tien'),
    doi_tac: p.get('doi-tac'),
    han: laLocHan(han) ? han : null,
    xong: xong === '7-ngay' || laKyThang(xong) ? xong : null,
    tai_san: p.get('tai-san'),
    pha: p.get('pha'),
    kenh: p.get('kenh'),
    tt: TT_DANG_MO.includes(p.get('tt') ?? '') ? p.get('tt') : null,
    loai: LOAI_VIEC.some((l) => l.ma === p.get('loai')) ? p.get('loai') : null,
    tao: laKyThang(tao) ? tao : null,
    cho: cho === NGUONG_CHAM_NGAY || cho === NGUONG_QUA_HAN_NGAY ? cho : null,
  };
}

export const soBoLocDangBat = (l: BoLoc) => [l.nguoi, l.tag, l.brand, l.linh_vuc, l.uu_tien, l.doi_tac, l.han, l.xong, l.tai_san, l.pha, l.kenh, l.tt, l.loai, l.tao, l.cho].filter((x) => x !== null).length;

/** Bậc cửa sổ lịch sử việc ĐÃ ĐÓNG mà app nạp (ngày). MỘT nguồn cho cả hook nạp (du-lieu.ts useViecDaDong) lẫn phép tính
 *  "bộ lọc này cần nạp bao xa" bên dưới — lệch nhau thì danh sách theo kỳ thiếu việc mà không báo. */
export const BAC_NGAY = [70, 200, 400] as const;
export type BacNgay = 0 | (typeof BAC_NGAY)[number];
export const NGAY_LICH_SU_TOI_DA = BAC_NGAY[BAC_NGAY.length - 1];

const dauKyCuNhat = (l: Pick<BoLoc, 'xong' | 'tao'>): number | null => {
  const dau = [l.xong, l.tao].filter(laKyThang).map((k) => +khoangKy(k)![0]);
  return dau.length ? Math.min(...dau) : null;
};

/** Cửa sổ lịch sử việc ĐÃ ĐÓNG mà bộ lọc theo kỳ cần. 0 = danh sách chính (mọi việc mở + 100 việc đóng gần nhất) là đủ.
 *  Kỳ cũ hơn bậc lớn nhất vẫn chỉ nạp bậc lớn nhất — `kyCuHonLichSu` cho nơi hiển thị biết để báo thiếu. */
export function bacLichSuCan(l: Pick<BoLoc, 'xong' | 'tao'>, bay_gio = Date.now()): BacNgay {
  const dau = dauKyCuNhat(l);
  if (dau === null) return 0;
  const ngay = Math.ceil((bay_gio - dau) / 86400_000);
  return BAC_NGAY.find((b) => ngay <= b) ?? NGAY_LICH_SU_TOI_DA;
}

/** Kỳ được lọc bắt đầu TRƯỚC cửa sổ lịch sử lớn nhất → danh sách chắc chắn thiếu phần cũ, nơi hiển thị phải nói ra. */
export function kyCuHonLichSu(l: Pick<BoLoc, 'xong' | 'tao'>, bay_gio = Date.now()): boolean {
  const dau = dauKyCuNhat(l);
  return dau !== null && (bay_gio - dau) / 86400_000 > NGAY_LICH_SU_TOI_DA;
}

// Tên ngắn của bộ lọc theo kỳ — dùng chung cho chip ở thanh lọc và tiêu đề ngăn danh sách.
export const tenLocXong = (x: string) => (x === '7-ngay' ? 'Xong 7 ngày qua' : `Xong ${tenKy(x)}`);
export const tenLocTao = (x: string) => `Mở mới ${tenKy(x)}`;
export const tenLocCho = (n: number) => `Chờ duyệt từ ${n} ngày`;

/** Việc mà trang /danh-sach hiện cho một bộ lọc. Mục tiêu bỏ ra (có trang OKR riêng). Việc đã xong chỉ hiện khi người dùng
 *  bật "Hiện việc đã xong", đang lọc theo xong / tạo trong kỳ, hoặc đang TÌM (?q=) — tìm một việc cũ mà ra rỗng chỉ vì nó
 *  đã đóng là lỗi "tìm không chạy" (owner 30/09, VTask#392). Một hàm cho trang VÀ cho test "con số ↔ danh sách". */
export function viecTrangDanhSach(ds: Viec[], l: BoLoc, xem_xong = false, hom_nay?: string, bay_gio?: number): Viec[] {
  const dang_tim = !!l.tim.trim();
  return apBoLoc(ds.filter((v) => !laMucTieu(v) && (xem_xong || dang_tim || !!l.xong || !!l.tao || v.mo)), l, hom_nay, bay_gio);
}

// `brand=khong` = việc KHÔNG gắn brand nào (nhãn thật luôn có dạng `brand:<slug>`, không đụng nhau).
export const KHONG_BRAND = 'khong';

// `hom_nay` / `bay_gio` chỉ để kiểm thử — bỏ trống là ngày giờ máy.
// Sự kiện đối thủ / thị trường (tag doi-thu | thi-truong, lib/su-kien.ts) do bộ quét tạo hàng loạt: ẩn khỏi các danh sách chung cho đến khi
// có người nhận (hoặc lọc thẳng theo tag) — nơi xem chính là trang Đối thủ / Thị trường. Có người nhận = việc thật, hiện lại.
export const laSuKienChuaNhan = (v: Viec) => !v.nguoi.length && (v.tags.includes('doi-thu') || v.tags.includes('thi-truong'));

export function apBoLoc(ds: Viec[], l: BoLoc, hom_nay?: string, bay_gio?: number): Viec[] {
  const tim = l.tim.trim().toLowerCase();
  return ds.filter((v) => {
    if (tim && !khopTim(v, tim)) return false;
    if (l.nguoi === 'chua-giao' && v.nguoi.length) return false;
    if (typeof l.nguoi === 'number' && !v.nguoi.includes(l.nguoi)) return false;
    if (l.tag && !v.tags.includes(l.tag)) return false;
    if (!l.tag && laSuKienChuaNhan(v)) return false;
    if (l.brand === KHONG_BRAND ? v.brand !== null : l.brand && v.brand !== l.brand) return false;
    if (l.linh_vuc && !v.linh_vuc.includes(l.linh_vuc)) return false;
    if (l.uu_tien && v.uu_tien !== l.uu_tien) return false;
    if (l.doi_tac && !v.doi_tac.includes(l.doi_tac)) return false;
    if (l.han && !khopHan(v, l.han, hom_nay)) return false;
    if (l.xong && !(l.xong === '7-ngay' ? xongTrong7Ngay(v, bay_gio) : xongTrongKy(v, l.xong))) return false;
    if (l.tao && !taoTrongKy(v, l.tao)) return false;
    // "Chờ duyệt từ N ngày": CÙNG luật với số ở Sức khoẻ vận hành (tt:cho-duyet, tuổi tính từ lần cập nhật cuối).
    if (l.cho && !(v.mo && v.tt === 'tt:cho-duyet' && tuoiNgay(v.cap_nhat_luc, bay_gio) >= l.cho)) return false;
    if (l.tai_san && !v.tai_san.includes(l.tai_san)) return false;
    if (l.pha && !v.pha.includes(l.pha)) return false;
    if (l.kenh && !v.kenh.includes(l.kenh)) return false;
    if (l.tt && v.tt !== l.tt) return false;
    if (l.loai && v.loai !== l.loai) return false;
    return true;
  });
}

// Nhãn + người cho việc TẠO NHANH (Kanban, danh sách): mặc định AGENTS.md mục 6 của VTask, rồi kế thừa
// bộ lọc đang bật — đang lọc "tag: q4" mà thêm việc thì việc đó phải hiện ngay trong khung nhìn này.
export function macDinhTaoNhanh(l: BoLoc, tt: string) {
  const nhan = ['loai:viec', tt, 'che-do:duyet', l.uu_tien || 'uu-tien:p2', 'agent:chung', l.linh_vuc || 'linh-vuc:ca-nhan'];
  if (l.brand && l.brand !== KHONG_BRAND) nhan.push(l.brand);
  if (l.tai_san) nhan.push('tai-san:' + l.tai_san);
  if (l.pha) nhan.push('pha:' + l.pha);
  if (l.kenh) nhan.push('kenh:' + l.kenh);
  return { nhan, tags: l.tag ? [l.tag] : [], doi_tac: l.doi_tac ? [l.doi_tac] : [], nguoi: typeof l.nguoi === 'number' ? [l.nguoi] : [] };
}

// Trang "Theo brand": một cột cho mỗi brand có việc đang mở (theo thứ tự `brands`, rồi brand lạ không có trong
// nhan.yml), cộng cột "Không brand". Mỗi cột: trễ hạn trước, rồi ưu tiên (Khẩn → Thấp), rồi hạn gần trước (không
// hạn xuống cuối). Mục tiêu không tính — như Kanban.
export interface CotBrand { ma: string; ten: string; ds: Viec[]; tre: number }
export function cotTheoBrand(ds: Viec[], brands: string[], hom_nay?: string): CotBrand[] {
  const mo = ds.filter((v) => v.mo && !laMucTieu(v));
  const la = [...new Set(mo.map((v) => v.brand).filter((b): b is string => !!b && !brands.includes(b)))].sort();
  const tre = (v: Viec) => khopHan(v, 'tre', hom_nay);
  const xep = (a: Viec, b: Viec) =>
    Number(tre(b)) - Number(tre(a)) || thuTuUuTien(a.uu_tien) - thuTuUuTien(b.uu_tien) || (a.han || '9999').localeCompare(b.han || '9999') || a.so - b.so;
  return [...brands, ...la, KHONG_BRAND]
    .map((ma) => {
      const cua = mo.filter((v) => (ma === KHONG_BRAND ? v.brand === null : v.brand === ma)).sort(xep);
      return { ma, ten: ma === KHONG_BRAND ? 'Không brand' : ma.replace(/^brand:/, ''), ds: cua, tre: cua.filter(tre).length };
    })
    .filter((c) => c.ds.length);
}
